export const lessonLink = 'https://learn.movecastle.info/courses/move-on-sui';

export const courseDetailSectionId = 'course-detail';
